<template>
  <b-form-select
    v-model="local_value"
    :options="options"
    :disabled="disabled"
  ></b-form-select>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { mapActions } from "vuex";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
    disabled: false,
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    options: [],
  }),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionGetPlataformas"]),
  },
  async created() {
    let options = await this.ActionGetPlataformas();

    this.options = [
      {
        value: null,
        text: "Selecione uma Plataforma",
      },
      ...options,
    ];
  },
};
</script>
